import styled from 'styled-components';
import { CommonDiv } from 'styles/common';
import CloseIcon from 'assets/images/close-24.svg';

const ModalCloseIcon = styled.img.attrs({
  src: CloseIcon
})`
  float: right;
  transition: opacity 0.25s ease-in-out;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

const ModalTitle = styled(CommonDiv)`
  clear: both;
  text-align: left;
  font-size: 24px;
  margin-bottom: 20px;
`;

const ModalText = styled(CommonDiv)`
  text-align: left;
  font-size: 18px;
  margin-bottom: 1em;
`;

const ModalCancel = styled.a`
  text-align: left;
  color: ${props => props.theme && props.theme.color.error};
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  left: 0;
  transition: opacity 0.25s ease-in-out;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;

const ModalButtonConfirm = styled.button`
  border: 0;
  padding: 0.72em 0;
  font-family: ${props => props.theme.fontFamily};
  font-size: 1em;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  background-color: ${props =>
    props.disabled ? props.theme.color.label : props.theme.color.primary};
  margin-right: 0.938em;
  width: 100%;
  max-width: 140px;
  transition: opacity 0.25s ease-in-out;
  &:hover {
    cursor: pointer;
  }
`;

const ModalLine = styled.div`
  margin-top: 20px;
  height: 1px;
  background-color: ${props => props.theme.color.border};
  margin: 0px -15px 15px -30px;
`;

const Form = styled.div`
  margin-right: 15px;
  input {
    ::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: ${props => props.theme.color.label};
      opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: ${props => props.theme.color.label};
    }

    ::-ms-input-placeholder {
      /* Microsoft Edge */
      color: ${props => props.theme.color.label};
    }
  }
`;

const PriceInput = error => {
  return {
    outline: 'none',
    boxSizing: 'border-box',
    padding: '11px 0px 11px 10px',
    width: '100%',
    marginTop: '4px',
    borderRadius: '4px',
    backgroundColor: '#ffffff',
    border: 'solid 1px',
    borderColor: error ? '#e34d57' : '#dbdce1',
    fontSize: '1em',
    color: '#3a3d4d'
  };
};

export {
  ModalCloseIcon,
  ModalTitle,
  ModalText,
  ModalCancel,
  ModalButtonConfirm,
  ModalLine,
  Form,
  PriceInput
};
